import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from "../../core/services/api.service";
import { environment } from '../../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HeaderService } from 'src/app/core/services/header.service';
import { Location } from '@angular/common';
import { UserService } from 'src/app/core/services/user.service';
import { zoomMeetingAction, zoomMeetingButtonLabel } from 'src/app/core/utils/zoom-meeting-status';

@Component({
  selector: 'app-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.scss']
})
export class ZoomComponent implements OnInit, OnDestroy {
  userDetails: any = [];
  tabs = ['My Zoom', 'Upcoming', 'Past'];
  activeIndex: number = 1;
  page = 1;
  isLoading = false;
  isLoadingSingle = false;
  hasMore = true;
  zoomMeetingList: any[] = [];
  zoomMeetingTitle = "";
  meetingDetails: any = {};
  meetingJoinDetails = {};
  isModalOpen = false;
  currentZoomId: number;
  is_subscribed: any = 0;
  is_id: number;
  private routerSub: Subscription;

  constructor(private route: ActivatedRoute, private userService: UserService, private apiService: ApiService, private authService: AuthService, private router: Router, private http: HttpClient, private headerService: HeaderService, private _location: Location) {
    this.loadCurrentUser();
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0); // 👈 scroll to top
      }
    });
  }
  // Reads the logged in user on demand (the user can sign in from the popup after this page loaded)
  loadCurrentUser() {
    if (localStorage.getItem('currentUser')) {
      const userData = this.authService.decryption(localStorage.getItem('currentUser'));
      this.is_subscribed = userData['response'].is_subscribed;
      this.is_id = userData['response'].id;
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if (this.activeIndex === 0) {
      return;
    }
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;
    if (scrollPosition >= pageHeight - 100) {
      this.getZoomMeeting();
    }
  }

  ngOnInit() {
    this.getZoomMeeting()
    this.route.paramMap.subscribe(params => {
      const slug = params.get('zoom_id'); 
      if(slug){
        this.getZoomMeetingDetails(slug)
      }else{
        this.getZoomMeetingDetails(null)
      }
      
    });
  }

  ngOnDestroy() {
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }

  openModal(id?: number) {
    if (id) {
      this.joinMeeting(id)
    } else {
      this.joinMeeting(this.currentZoomId)
    }
  }

  closeModal() {
    this.isModalOpen = false;
  }

  setTab(index: number) {
    this.activeIndex = index;
    this.page = 1;
    this.isLoading = false;
    this.hasMore = true;
    this.zoomMeetingList = [];
    if (index == 1 || index == 2) {
      this.getZoomMeeting()
    }
  }

  joinMeeting(id: number) {
    this.apiService
      .callGetAPI('v2/zoom/meeting/' + id, environment.userApiUrl)
      .subscribe(data => {
        if (data['statusCode'] === 200 && data['error'] === false && data['response'].status == "success") {
          this.loadCurrentUser();
          this.meetingJoinDetails = data['response'].data;
          this.isModalOpen = true;
        }
      },
        error => {
          if (error.status == "401" && !localStorage.getItem('currentUser')) {
            localStorage.setItem('myUrl', 'currrent');
            this.userService.displayPopup('sign-in');
          } else {
            this.apiService.failureResponse(error, true);
          }

        }
      );
  }

  getZoomMeetingDetails(id?: string) {
    this.isLoadingSingle = true;

    this.apiService
      .callGetAPI('v2/zoom/meeting-details/' + id, environment.userApiUrl)
      .subscribe(
        data => {
          this.isLoadingSingle = false;

          if (data['statusCode'] === 200 && data['error'] === false) {
            const meeting = data['response'];
            this.loadCurrentUser();
            this.currentZoomId = meeting.id;

            // 👇 yaha buttonLabel add ho raha hai
            this.meetingDetails = {
              ...meeting,
              buttonLabel: this.getButtonLabel(meeting)
            };
          }
        },
        error => {
          this.isLoadingSingle = false;
        }
      );
  }

  getZoomMeeting() {
    if (this.isLoading || !this.hasMore) return;

    this.isLoading = true;

    const eventType =
      (this.activeIndex === 1 && 'upcoming') ||
      (this.activeIndex === 2 && 'past') ||
      '';

    this.apiService
      .callGetAPI(
        'v2/zoom/meetings?page=' + this.page + '&event=' + eventType,
        environment.userApiUrl
      )
      .subscribe(
        data => {
          if (data['statusCode'] === 200 && data['error'] === false) {
            const response = data['response'];

            this.zoomMeetingTitle = response.title;
            this.loadCurrentUser();

            // 👇 yaha buttonLabel add ho raha hai
            const updatedMeetings = response.data.map((meeting: any) => ({
              ...meeting,
              buttonLabel: this.getButtonLabel(meeting)
            }));

            this.zoomMeetingList = [
              ...this.zoomMeetingList,
              ...updatedMeetings
            ];

            this.hasMore = response.next_page_url !== null;
            this.page++;
          }

          this.isLoading = false;
        },
        error => {
          this.isLoading = false;
        }
      );
  }

  // joinZoomMeeting(id:number, event: Event){
  //   event.stopPropagation();  
  //   this.meetingClick.emit(id);
  // }
  disabledBtn(id: number, event: Event) {
    event.stopPropagation();
  }
  watchRecording(meeting: any, event: Event) {
    event.stopPropagation();
    if (meeting && meeting.recorded_video_id) {
      this.router.navigate(['video/' + meeting.recorded_video_id]);
    } else if (meeting && meeting.recorded_url) {
      window.open(meeting.recorded_url, '_blank');
    }
  }

  handleMeetingAction(meeting: any, event: Event) {
    this.loadCurrentUser();
    switch (zoomMeetingAction(meeting, this.is_subscribed)) {
      case 'subscribe':
        this.router.navigate(['subscription']);
        break;
      case 'join':
        this.joinMeeting(meeting.id);
        break;
      case 'recording':
        this.watchRecording(meeting, event);
        break;
    }
  }

  getButtonLabel(meeting: any): string {
    return zoomMeetingButtonLabel(meeting, this.is_subscribed);
  }

  backClick() {
    this._location.back();
  }


}
